import { installTonWalletController, type TonWalletController } from './controller'

let controller: TonWalletController | null = null

export const installTonWalletFeature = async (): Promise<TonWalletController> => {
  const [authModule, addressModule, restoreModule, sessionModule, serviceModule] =
    await Promise.all([
      import('@/api/endpoints/auth'),
      import('./auth/normalize-address'),
      import('./session/restore'),
      import('./session/storage'),
      import('./wallet'),
    ])
  const { authApi } = authModule
  const { normalizeTonAddress } = addressModule
  const { restoreTonSession } = restoreModule
  const { sessionService } = sessionModule
  const { walletService } = serviceModule

  if (controller) {
    sessionService.refreshSessionValidity()
    installTonWalletController(controller)
    return controller
  }

  controller = {
    selectors: {
      isConnected: walletService.isConnected,
      isAuthenticated: walletService.isAuthenticated,
      hasActiveSession: walletService.hasActiveTonConnectSession,
      isRestoreSettled: walletService.isTonConnectRestoreSettled,
      isBackendAuthRestoring: walletService.isBackendAuthRestoring,
      isConnecting: walletService.isConnecting,
      address: walletService.address,
      shortAddress: walletService.shortAddress,
      user: walletService.user,
      hasRestorableSession: sessionService.hasRestorableSession,
    },
    commands: {
      setCallbacks: (callbacks) => {
        walletService.setCallbacks(callbacks)
      },
      setUser: (user) => {
        walletService.user.value = user
      },
      connect: () => walletService.connect(),
      recheckBackendSession: () => walletService.recheckBackendSession(),
      reconnectForFreshProof: () => walletService.reconnectForFreshProof(),
      disconnect: (reason) => {
        walletService.disconnect(reason)
      },
      openExplorer: (txHash) => {
        walletService.openExplorer(txHash)
      },
      openAddress: (address) => {
        walletService.openAddress(address)
      },
      sendTransaction: (request) => walletService.sendTransaction(request),
      restoreSession: () =>
        restoreTonSession({
          session: {
            get: () => sessionService.getSession(),
            isValid: (session) => sessionService.isSessionValid(session),
            clear: () => {
              sessionService.clearSession()
            },
            touch: () => {
              sessionService.updateSessionTimestamp()
            },
          },
          wallet: {
            isConnected: () => walletService.isConnected.value,
            disconnect: () => {
              walletService.disconnect()
            },
            setUser: (user) => {
              walletService.user.value = user
            },
          },
          auth: {
            currentUser: async () => {
              const response = await authApi.getCurrentUser()
              return response.success && response.data ? response.data : null
            },
          },
          normalizeAddress: normalizeTonAddress,
        }),
      hasRestorableSession: () => sessionService.refreshSessionValidity(),
    },
  }
  sessionService.refreshSessionValidity()
  installTonWalletController(controller)
  return controller
}
